module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-p-500-66729e09b9ab7014928419e3b23e6fb0.jpg";